import { http } from "@/utils/request";
import type {
  CoursesResponse,
  GetCoursesParams,
  CourseStatus,
  saveCourseParams,
  CourseDetailType,
} from "@/types/course.types";

export const courseService = {
  // 获取课程列表
  getCourses: async (params: GetCoursesParams): Promise<CoursesResponse> => {
    return http.get<CoursesResponse>("/course/list", params);
  },

  // 导出课程列表
  exportCourses: async (params: GetCoursesParams): Promise<Blob> => {
    return http.get<Blob>("/course/export", params, {
      responseType: "blob",
    });
  },

  // 更新课程状态
  updateCourseStatus: async (
    id: string,
    status: CourseStatus,
    reason?: string
  ): Promise<void> => {
    return http.post("/course/update-status", {
      id,
      status,
      reason,
    });
  },

  // 停用课程
  disableCourse: async (id: string, reason: string): Promise<void> => {
    return http.put(`/course/${id}/disable`, { reason });
  },

  // 启用课程
  enableCourse: async (id: string): Promise<void> => {
    return http.put(`/course/${id}/enable`);
  },
  
  // 课程详情
  getCourseDetail: async (id: string,cate: string): Promise<CourseDetailType> => {
    return http.get(`/course/${id}/${cate}`)
  },

  // 更新课程信息
  saveCourse: async (params: saveCourseParams) => {
    return http.put(`/course/save`,params)
  }
};
